import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import type { SpofRecord } from "../types";
import { RiskChip } from "./Chips";
import { PendingValue } from "./PendingValue";

export default function SpofMitigationsDialog({
  record,
  onClose,
}: {
  record: SpofRecord | null;
  onClose: () => void;
}) {
  return (
    <Dialog open={!!record} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{record?.spof_id} - proposed mitigations</DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                "Mitigation ID",
                "Proposed mitigation",
                "Complexity",
                "Phase",
                "Residual risk",
              ].map((label) => (
                <TableCell key={label} sx={{ fontWeight: 600 }}>
                  {label}
                </TableCell>
              ))}
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                Total cost (SAR)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(record?.mitigations ?? []).map((mitigation, index) => (
              <TableRow key={mitigation.mitigation_id ?? index}>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {mitigation.mitigation_id ?? <PendingValue />}
                </TableCell>
                <TableCell>
                  {mitigation.mitigation_short ?? <PendingValue />}
                </TableCell>
                <TableCell>
                  {mitigation.implementation_complexity ?? <PendingValue />}
                </TableCell>
                <TableCell>
                  {mitigation.implementation_phase ?? <PendingValue />}
                </TableCell>
                <TableCell>
                  <RiskChip level={mitigation.residual_final_risk_category} />
                </TableCell>
                <TableCell align="right">
                  {mitigation.total_cost_sar === null ? (
                    <PendingValue />
                  ) : (
                    Math.round(mitigation.total_cost_sar).toLocaleString()
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
}
